import React from 'react';
import { Switch, Icon, Typography } from 'antd';
import cn from 'classnames';
import styles from './ToggleOnlyThisPeriod.module.scss';

const { Text } = Typography;

export const ToggleOnlyThisPeriod = ({ enabled, onChange }) => {
  return (
    <div className={cn(styles.root)}>
      <Switch
        checkedChildren={<Icon type="check" />}
        unCheckedChildren={<Icon type="close" />}
        checked={enabled}
        onChange={onChange}
      />
      <Text className={cn(styles.text, { [styles.active]: enabled })}>
        Отобразить события периода
      </Text>
    </div>
  )
}